// TODO: all functions need major refactor
// FIXME: please clean this shit
import { getTodayDate, persianMonthNameConvertor } from '@/helpers/dateManager';
const ONE_DAY_TIMESTAMP = 24 * 3600;
export type DateObject = {
  day: number;
  year: number;
  month: number;
  ts: number;
  is_day_disabled?: boolean;
  min_book_day?: number;
  nextRangeDays?: number;
} | null;
class DatePickerManager {
  static instance: any;
  constructor() {
    if (!DatePickerManager.instance) {
      DatePickerManager.instance = this;
    }
    return DatePickerManager.instance;
  }
  getJalaliMonths = () => {
    const JALALI_MONTHS = [{
      id: 1,
      title: 'فروردین'
    }, {
      id: 2,
      title: 'اردیبهشت'
    }, {
      id: 3,
      title: 'خرداد'
    }, {
      id: 4,
      title: 'تیر'
    }, {
      id: 5,
      title: 'مرداد'
    }, {
      id: 6,
      title: 'شهریور'
    }, {
      id: 7,
      title: 'مهر'
    }, {
      id: 8,
      title: 'آبان'
    }, {
      id: 9,
      title: 'آذر'
    }, {
      id: 10,
      title: 'دی'
    }, {
      id: 11,
      title: 'بهمن'
    }, {
      id: 12,
      title: 'اسفند'
    }];
    return JALALI_MONTHS;
  };

  // Converts a date type YYYY-MM-DD to YYYY/MM/DD
  beautifyDate = date => {
    return date ? date.replace(/-/g, '/') : null;
  };
  nextRangeDays = (days: number) => {
    // Get current date at UTC start of day
    const now = new Date();
    const todayUTC = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
    todayUTC.setUTCHours(0, 0, 0, 0);
    const futureDate = new Date(todayUTC.getTime());
    futureDate.setUTCDate(futureDate.getUTCDate() + days);
    return {
      day: futureDate.getUTCDate(),
      month: futureDate.getUTCMonth() + 1,
      year: futureDate.getUTCFullYear(),
      ts: Math.floor(futureDate.getTime() / 1000)
    };
  };
  calculateFinalPrice = (price, lastMinutes, daily, houseSpecialDiscountPercent) => {
    // Calculate the discounted price
    const discountedPrice = price - lastMinutes - daily;

    // Calculate the percentage reduction
    const reductionAmount = houseSpecialDiscountPercent / 100 * discountedPrice;

    // Calculate the final price
    const finalPrice = discountedPrice - reductionAmount;
    return finalPrice;
  };
  // Applies calendar to existing month
  applyCalendar = (month, calendar, calendarCache, minDays) => {
    const monthId = `${month.year}-${month.month < 10 ? '0' + month.month : month.month}`;
    const todayDateTs = getTodayDate().ts;
    if (!calendarCache[monthId] && calendar[monthId]) {
      calendarCache[monthId] = new Map();
      for (const calendarDay of calendar[monthId]) {
        calendarCache[monthId].set(calendarDay.day, calendarDay);
      }
    }
    const monthDaysMap = new Map();
    for (let i = 0; i < month.days.length; i++) {
      const day = month.days[i];
      monthDaysMap.set(day.day, day);
      const calendarDay = calendarCache[monthId]?.get(day.day);
      if (calendarDay) {
        day.is_day_disabled = !calendarDay?.is_bookable || calendarDay.units_count - (calendarDay.unavailable_count + calendarDay.disable_count) === 0;
        day.price = calendarDay.price;
        day.is_holiday = calendarDay.is_holiday;
        day.unitCount = calendarDay.units_count;
        day.unavailableCount = calendarDay.unavailable_count;
        day.is_reserved = calendarDay.units_count === 1 && calendarDay.unavailable_count === 1;
        day.is_disabled = calendarDay.units_count > 1 ? calendarDay.units_count - (calendarDay.unavailable_count + calendarDay.disable_count) === 0 : calendarDay.disable_count === 1;
        day.disableCount = calendarDay.disable_count;
        day.is_instant = calendarDay.is_instant;
        day.is_overpriced = calendarDay.is_overpriced;
        day.isPassed = day.ts < todayDateTs;
        day.discount = calendarDay.discount;
        day.isPeak = calendarDay.is_peak;
        day.min_book_day = minDays || calendarDay.min_book_day || 1;
        day.min_book = minDays || calendarDay.min_book_day || 1;
        day.is_unavailable = calendarDay.is_unavailable;
        if (day.ts >= todayDateTs) {
          day.raw_price = parseInt(calendarDay?.price?.raw_price || 0, 10);
          day.specialDiscount = calendarDay?.price?.price_after_discount !== calendarDay?.price?.raw_price ? calendarDay?.price?.price_after_discount : 0;
        }
      }
    }
    month.days = Array.from(monthDaysMap.values());
  };

  // Applies reservation rules to existing month
  applyReserveRules = (monthsList, calendar, checkedInDate, checkOutDate, fsdd, oldCheckin, minDays) => {
    if (oldCheckin?.ts !== checkedInDate?.ts && !checkOutDate) {
      fsdd = null;
    }
    const months = monthsList;
    let firstDisabledDay = checkedInDate && fsdd && fsdd.ts > checkedInDate.ts ? fsdd : null;
    const calendarCache = {};
    for (let m = 0; m < months.length; m++) {
      const month = months[m];
      if (calendar) this.applyCalendar(month, calendar, calendarCache, minDays);
      const days = month.days;
      const indexToLoop = month.month === checkedInDate?.month && month.year === checkedInDate?.year && days.length > 26 ? checkedInDate.day : 0;
      if (checkedInDate) {
        for (let i = indexToLoop; i < days.length; i++) {
          const day = days[i];
          const dayTs = day.ts;
          const checkInTs = checkedInDate.ts;
          const minBookDayTs = checkedInDate.min_book_day * ONE_DAY_TIMESTAMP;
          // Disable all dates that are after first disable date
          // This dates cannot be checkout
          if (firstDisabledDay && firstDisabledDay.ts < dayTs && !checkOutDate) {
            day.is_day_disabled = true;
          }

          // This line finds the first disabled date after checkin
          // This day is selectable itself and should not be disable for select
          if (day.is_day_disabled && !firstDisabledDay && dayTs > checkInTs) {
            day.is_day_disabled = false;
            firstDisabledDay = day;
          }
          // If day is not selectable because of min_book_day of checkin, we should disable it
          // The min_book_day for this day should be checkin min_book_day.
          // This is because the hint value shows the reason of being disabled based on this min_book_day
          if (dayTs > checkInTs && checkedInDate.min_book_day && dayTs - checkInTs < minBookDayTs) {
            day.is_day_disabled = true;
            day.min_book_day = checkedInDate.min_book_day;
          }
          // Having a checkin, first disabled date is selectable itself as a checkout
          if (firstDisabledDay && dayTs === firstDisabledDay.ts && dayTs - checkInTs >= minBookDayTs) {
            day.is_non_bookable = false;
            day.is_day_disabled = false;
          }
          // Having checkout, we can release first disabled date
          // This is because in last if we have made it selectable. After select it is
          // not selectable as a checkin again
          if (firstDisabledDay && dayTs === firstDisabledDay.ts && checkOutDate) {
            day.is_day_disabled = true;
          }
          if (firstDisabledDay && dayTs === firstDisabledDay.ts && dayTs - checkInTs >= minBookDayTs && checkOutDate) {
            day.is_non_bookable = true;
            day.is_day_disabled = true;
          }
          if (dayTs - checkInTs < minBookDayTs && checkOutDate && dayTs - checkInTs > 0) {
            day.is_day_disabled = false;
            day.min_book_day = day.min_book;
          }
          if (checkOutDate) {
            firstDisabledDay = null;
          }
        }
      }
    }
    return {
      months,
      firstDisabledDay,
      checkedInDate
    };
  };

  // Uses two functions above to resolve month name
  monthNameConvertor = (date: {
    month: number;
  }, type: string = 'JALALI') => {
    return persianMonthNameConvertor(date);
  };
}
const instance = new DatePickerManager();
export default instance;